<template>
  <label class="radio-input-component" :class="{ 'radio-input-component--disabled': disabled }">
    <input
      type="radio"
      class="radio-input-component__input"
      :name="name"
      :value="optionValue"
      :checked="modelValue === optionValue"
      @click="handleClick"
      :disabled="disabled"
    />
    <span class="radio-input-component__mark"></span>
    <span class="radio-input-component__label">{{ label }}</span>
  </label>
</template>

<script>
  export default {
    name: 'RadioInputComponent',
    props: {
      modelValue: {
        type: [String, Number],
        default: null,
      },
      optionValue: {
        type: [String, Number],
        required: true,
      },
      name: {
        type: String,
        required: true,
      },
      label: {
        type: String,
        required: true,
      },
      allowDeselect: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    methods: {
      handleClick() {
        if (this.allowDeselect && this.modelValue === this.optionValue) {
          this.$emit('update:modelValue', null);
        } else {
          this.$emit('update:modelValue', this.optionValue);
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .radio-input-component {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    user-select: none;

    &__input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      margin: 0;
      padding: 0;
      z-index: 1;

      &:disabled {
        cursor: default;
      }
    }

    &__mark {
      position: relative;
      display: inline-block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 1px solid $green;
      background: $white;
      margin-right: 8px;
      transition: all 0.2s ease;
      flex-shrink: 0;
      z-index: 0;
    }

    &__label {
      font: $fira-16-20;
      color: $base;
      z-index: 0;
    }

    &__input:checked + &__mark {
      background: linear-gradient(90deg, $green 0%, $blue 100%);
      border-color: transparent;
    }

    &__input:checked + &__mark::after {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: $white;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    &:hover &__input:not(:disabled) ~ &__mark {
      border-color: $blue;
    }

    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }
</style>
